const promoBreakpoints = ['375px', '744px', '1440px'];

promoBreakpoints.mobile375 = promoBreakpoints[0];
promoBreakpoints.tablet744 = promoBreakpoints[1];
promoBreakpoints.desktop1440 = promoBreakpoints[2];

export default promoBreakpoints;
